export const DIPLOMA_FILTER = {
  ALL: 0,
  CERTIFICATIONS: 1,
  CONSTANCIES: 2,
} as const;
